import { useState } from 'react'

export function IntegritetsLank({ style }) {
  const [oppen, setOppen] = useState(false)
  return (
    <>
      <span
        onClick={() => setOppen(true)}
        style={{ fontSize: '.78rem', color: '#999', textDecoration: 'underline', cursor: 'pointer', ...style }}
      >
        Integritet & GDPR – vad sparas om mig?
      </span>
      {oppen && <IntegritetsModal onClose={() => setOppen(false)} />}
    </>
  )
}

export function IntegritetsModal({ onClose }) {
  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal-box" style={{ maxWidth: 480, maxHeight: '85vh' }}>
        <div className="modal-header">
          <h3>Integritet & GDPR</h3>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body" style={{ textAlign: 'left', fontSize: '.85rem', lineHeight: 1.6, color: '#444' }}>
          <p style={{ marginBottom: 16 }}>
            E.ON Schema behandlar personuppgifter som behövs för att administrera och schemalägga arbetet. Det kan exempelvis vara namn, e-postadress, KID, anställningsnummer, avdelning samt uppgifter om arbetspass och ansökningar, såsom ledighet, passbyte och ATF.
          </p>
          <p style={{ marginBottom: 16 }}>
            Uppgifterna används för personal- och schemaläggningsadministration och lagras hos databasleverantören Supabase.
          </p>
          <p>
            När anställningen avslutas anonymiseras dina personuppgifter automatiskt. Du har rätt att få information om vilka personuppgifter vi behandlar om dig och kan begära rättelse eller radering av dina uppgifter. Kontakta din chef för mer information.
          </p>
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary btn-full" onClick={onClose}>Stäng</button>
        </div>
      </div>
    </div>
  )
}
